import { render, staticRenderFns } from "./CustomersTableList.vue?vue&type=template&id=4eda35ad"
import script from "./CustomersTableList.vue?vue&type=script&lang=js"
export * from "./CustomersTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports